import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useUpdateEmailMutation } from "../../../../../redux/api/user/userAPI";
import { OvstErrorCode } from "../../../enums/ovst-error-codes";
import { AppRoute } from "../../../interfaces/app-routes";
import AppButton from "../../../ui-elements/buttons/app-button/app-button";
import AppInput from "../../../ui-elements/input/app-input";
import { emailRegex } from "../../../utils/regex";
import { showErrorMessage } from "../../../utils/toast";

export interface IChangeEmailFormInput {
  email: string;
}

const defaultFormValues: IChangeEmailFormInput = {
  email: "",
};

const ChangeEmailForm = () => {
  const navigate = useNavigate();

  const [isError, setIsError] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IChangeEmailFormInput>({
    defaultValues: { ...defaultFormValues },
  });

  const [updateEmail, { isLoading: isLoadingUpdateEmail }] =
    useUpdateEmailMutation();

  const onSubmit = (data: IChangeEmailFormInput) => {
    updateEmail({ email: data.email })
      .unwrap()
      .then(() => {
        navigate(AppRoute.VERIFY_EMAIL_OTP, {
          state: {
            email: data.email,
            whereTo: "dashboard/user-profile",
          },
        });
        reset({ ...defaultFormValues });
      })
      .catch((error) => {
        if (
          error.status === 412 &&
          error.ovstErrorCode === OvstErrorCode.OVST_CONS_0001
        ) {
          setIsError(true);
        } else {
          showErrorMessage(error.message || "Something went wrong");
        }
      });
  };

  useEffect(() => {
    if (errors.email) {
      setIsError(false);
    }
  }, [errors.email]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col>
            <AppInput
              name="email"
              placeholder="New Email"
              label="New Email"
              register={register("email", {
                required: "Email is required",
                pattern: {
                  value: emailRegex,
                  message: "Please enter a valid email",
                },
              })}
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          {isError && (
            <Col className="text-danger justify-content-center font-size-14 mt-2 text-center">
              Email is already associated with an account
            </Col>
          )}
        </Row>
        <Row className="mt-5">
          <Col>
            <AppButton
              text={`Send OTP`}
              size="medium"
              type="submit"
              isLoading={isLoadingUpdateEmail}
            />
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default ChangeEmailForm;
